import PropTypes from "prop-types";

const propTypes = {
  assigneeSelectionTypeOptions: PropTypes.string,
  deselectedClassrooms: PropTypes.array,
  deselectedStudents: PropTypes.array,
};

const DeselectedAssignees = ({ deselectedClassrooms, deselectedStudents }) => {
  const renderDeselectedAssignees = () => {
    if (deselectedClassrooms.length > 0) {
      return deselectedClassrooms.map((classroom) => (
        <li key={deselectedClassrooms}>{`${classroom}`}</li>
      ));
    } else {
      return deselectedStudents.map((student) => (
        <li key={deselectedStudents}>{`${student}`}</li>
      ));
    }
  };

  return (
    <>
      <b>These previous assignees were deselected.</b> To avoid losing work they
      may have completed, go back and reselect their names before saving.
      <ul>{renderDeselectedAssignees()}</ul>
    </>
  );
};

DeselectedAssignees.propTypes = propTypes;
export default DeselectedAssignees;
